import { css, Theme } from '@emotion/react'

export const emptyContainer = (theme: Theme) => css`
  align-items: center;
  padding: 31px 14px;
  color: ${theme.typographyColors.typographyFour};
`

export const container = (theme: Theme) => css`
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
  max-width: 850px;
  padding: 14px;
  border-radius: 14px;
  border: 1px solid ${theme.backgrounds.backgroundOne};
  background: ${theme.backgrounds.backgroundFour};
  box-shadow: ${theme.boxShadows.small};

  .MuiPaper-root {
    border-radius: 14px !important;
    border: 1px solid ${theme.backgrounds.backgroundOne};
    background: ${theme.backgrounds.backgroundFour};
    box-shadow: ${theme.boxShadows.small};

    &.MuiAccordion-root {
      &.Mui-expanded {
        margin: 0;
      }
    }

    .Mui-expanded {
      margin: 0;
    }

    :before {
      display: none;
    }
  }
`

export const itemContent = css`
  position: relative;
  overflow: hidden;
  min-height: 20px;
  max-height: 20px;
  max-width: 640px;

  * {
    margin: 0;
    padding: 0;
  }
`

export const title = (theme: Theme) => css`
  color: ${theme.typographyColors.typographyTwo};
  font-weight: 500;
  max-width: 574px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`

export const passageBadge = css`
  flex-shrink: 0;
  padding: 4px 8px;
  font-size: 11px;
  line-height: 14px;
`

export const index = (theme: Theme) => css`
  display: block;
  padding: 6px 10px;
  color: ${theme.typographyColors.typographyThree};
  font-weight: 700;
`

export const accordionSummary = (theme: Theme) => css`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
  height: 48px !important;
  max-height: 48px !important;
  min-height: 48px !important;
  gap: 8px;
  padding: 6px 6px 6px 12px;
  border-radius: 14px;
  box-sizing: border-box;
  background: ${theme.backgrounds.backgroundFive};
  box-shadow: ${theme.boxShadows.small};

  .MuiAccordionSummary-content {
    box-sizing: border-box;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 48px !important;
    max-height: 48px !important;
    min-height: 48px !important;
  }
`

export const accordionSummaryOpen = css`
  border-radius: 14px 14px 0 0;
`

export const accordionSummaryBlock = css`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
`

export const accordionSummaryEditBlock = css`
  flex: 1;
`

export const icon = (theme: Theme) => css`
  box-sizing: border-box;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 36px;
  height: 36px;
  padding: 8px;
  gap: 5px;
  border-radius: 10px;
  border: 1px solid ${theme.backgrounds.backgroundOne};
  background: ${theme.backgrounds.backgroundFour};
  box-shadow: ${theme.boxShadows.small};
`

export const iconEdit = (theme: Theme) => css`
  color: ${theme.backgrounds.backgroundOne};
`

export const iconCross = (theme: Theme) => css`
  color: ${theme.colors.red};
`

export const iconChevron = (theme: Theme) => css`
  width: 24px;
  height: 24px;
  transform: rotate(0);
  transition: transform 0.25s linear;
  color: ${theme.typographyColors.typographyThree};
`

export const iconChevronOpen = css`
  transform: rotate(180deg);
`

export const block = (theme: Theme) => css`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  height: 48px;
  padding: 6px 12px;
  border-radius: 14px;
  border: 1px solid ${theme.backgrounds.backgroundOne};
  background: ${theme.backgrounds.backgroundFour};
  box-shadow: ${theme.boxShadows.small};
`

export const answerTitle = (theme: Theme) => css`
  display: flex;
  flex-direction: row;
  align-items: baseline;
  gap: 8px;
  color: ${theme.typographyColors.typographyTwo};
`

export const questionTitle = (theme: Theme) => css`
  display: flex;
  flex-direction: column;
  height: 72px;
  padding: 12px;
  border-radius: 14px;
  gap: 8px;
  font-weight: 500;
  border: 1px solid ${theme.backgrounds.backgroundOne};
  background: ${theme.backgrounds.backgroundFour};
  box-shadow: ${theme.boxShadows.small};
  color: ${theme.typographyColors.typographyThree};
`

export const accordionDetails = css`
  display: flex;
  flex-direction: column;
  gap: 6px;
`

export const checked = css`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
`

export const checkedTitle = (theme: Theme) => css`
  color: ${theme.typographyColors.typographyThree};
  font-weight: 400;
`

export const answerLabel = (theme: Theme) => css`
  color: ${theme.typographyColors.typographyThree};
  font-weight: 700;
`

export const modal = css`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  width: 95vw;
  max-width: 95vw;
  max-height: 100vh;
  overflow: scroll;

  &::-webkit-scrollbar {
    display: none;
  }
`

export const modalContainer = (theme: Theme) => css`
  height: 100%;
  width: 95vw;
  max-width: 95vw;
  border-radius: 14px;
  border: 1px solid ${theme.backgrounds.backgroundOne};
  background: ${theme.backgrounds.backgroundFour};
  box-shadow: ${theme.boxShadows.small};
  box-sizing: border-box;
`

export const iconClose = (theme: Theme) => css`
  position: absolute;
  right: 24px;
  top: 24px;
  box-sizing: border-box;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 42px;
  height: 42px;
  padding: 8px;
  color: ${theme.typographyColors.typographyThree};
`

export const editTitleForm = (theme: Theme) => css`
  display: flex;
  align-items: center;
  column-gap: ${theme.spacing(1)};
  flex: 1;

  padding-right: ${theme.spacing(1)};
`

export const titleInput = css`
  width: 100%;
`

export const titleFormActions = (theme: Theme) => css`
  display: flex;
  column-gap: ${theme.spacing(1)};
`

export const iconButton = (theme: Theme) => css`
  box-sizing: border-box;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 36px;
  height: 36px;
  padding: 8px;
  gap: 5px;
  border-radius: 10px;
  border: 1px solid ${theme.backgrounds.backgroundOne};
  background: ${theme.backgrounds.backgroundFour};
  box-shadow: ${theme.boxShadows.small};

  svg {
    max-width: 100%;
  }
`

export const inputIcon = (theme: Theme) => css`
  color: ${theme.colors.typographyThree};
`
